import { render, staticRenderFns } from "./animated-integer.vue?vue&type=template&id=3b47ed27"
import script from "./animated-integer.vue?vue&type=script&lang=js"
export * from "./animated-integer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports